import { handleReferrerTracking } from '@foxrenderfarm/common'
import WrapPage from '@foxrenderfarm/internals/i18n/wrap-page'
// import { RootElement } from '@foxrenderfarm/common'
// import { GatsbyBrowser } from 'gatsby'
// import React from 'react'

export const wrapPageElement = WrapPage

// export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
//   <RootElement>{element}</RootElement>
// )

export const onClientEntry = () => {
  // function redirect_url() {
  //   const { host, href } = window.location
  //   if (host === 'ray.foxrenderfarm.com') {
  //     window.location.href = href.replace(/ray\.foxrenderfarm\.com/, 'foxrenderfarm.com')
  //   }
  // }
  // redirect_url()

  // 来源记录
  handleReferrerTracking('blockComefrom', 'comefrom')
  // 注册来源记录
  handleReferrerTracking('blockRegisterSource', 'registerSource')
}
